import Page from "../components/Layout/Page"
const PrivacyPolicy = () => {
  return (
    <Page title="Privacy Policy">
      <div id="otnotice-bb136219-5f7f-4ae5-96da-c53c525b88af" className="mt-5 prose max-w-none text-gray-500 prose-a:text-sky-700 prose-h2:text-sky-600"></div>
    </Page>
  )
}

export default PrivacyPolicy